<template>
    <div class="panel-content">
        <h3>Atualizar senha</h3>
        <form @submit.prevent="save">
            <div class="row">
                <div class="col-4">
                    <div class="form-group" :class="{ 'form-group--error': $v.oldpassword.$error }">
                        <input class="form__input" id="oldpassword" v-model.trim="$v.oldpassword.$model"/>
                        <label class="form__label" for="oldpassword" :class="{'up': $v.oldpassword.$model }">Senha atual</label>
                        <div class="error" v-if="!$v.oldpassword.required">Senha atual é obrigatório</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group" :class="{ 'form-group--error': $v.password.$error }">
                        <input class="form__input" id="password" v-model.trim="$v.password.$model"/>
                        <label class="form__label" for="password" :class="{'up': $v.password.$model }">Senha</label>
                        <div class="error" v-if="!$v.password.required">Senha é obrigatório</div>
                        <div class="error" v-if="!$v.password.minLength">Senha deve conter pelo menos {{$v.password.$params.minLength.min}} caracteres.</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group" :class="{ 'form-group--error': $v.passwordconfirm.$error }">
                        <input class="form__input" id="passwordconfirm" type="password" v-model.trim="$v.passwordconfirm.$model"/>
                        <label class="form__label" for="passwordconfirm" :class="{'up': $v.passwordconfirm.$model }">Confirmação de senha</label>
                        <div class="error" v-if="!$v.passwordconfirm.required">Confirmação de senha é obrigatório</div>
                        <div class="error" v-if="!$v.passwordconfirm.sameAsPassword">As senhas não conferem.</div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <button class="button" type="submit" :disabled="submitStatus === 'PENDING'">Salvar alterações</button>
                <button class="white">Cancelar alterações</button>
            </div>

            <!-- <p class="typo__p" v-if="submitStatus === 'OK'"></p> -->
            <p class="typo__p" v-if="submitStatus === 'ERROR'">Por favor, preencha todos os campos corretamente.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Processando...</p>
        </form>
    </div>
</template>
<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
    name: "Password",
    data(){
        return {
            submitStatus: null,
            oldpassword: "",
            password: "",
            passwordconfirm: "",
        }
    },
    validations: {
        oldpassword: {
            required
        },
        password: {
            required,
            minLength: minLength(8)
        },

        passwordconfirm: {
            required,
            sameAsPassword: sameAs('password')

        },
        
    },
}
</script>